import { AnyAction, Reducer } from 'redux';
import {
  GET_RETAILER_PRODUCT_PRICING_REQUEST,
  GET_RETAILER_PRODUCT_PRICING_RESPONSE,
  GET_RETAILER_PRODUCT_PRICING_ERROR,
} from '../../actions/Products';
import { IApiRequest, IRetailerProductPricing } from '../../types';

const initialState: IApiRequest<IRetailerProductPricing[]> = {
  data: [],
  error: '',
  UpdatedAt: null,
  loading: false,
};

const retailerProductPricingReducer: Reducer<IApiRequest<IRetailerProductPricing[]>> = (
  state: IApiRequest<IRetailerProductPricing[]> = initialState,
  action: AnyAction,
) => {
  switch (action.type) {
    case GET_RETAILER_PRODUCT_PRICING_REQUEST: {
      return {
        data: [],
        error: '',
        UpdatedAt: null,
        loading: true,
      };
    }
    case GET_RETAILER_PRODUCT_PRICING_RESPONSE: {
      return {
        data: action.response,
        error: '',
        UpdatedAt: new Date(),
        loading: false,
      };
    }
    case GET_RETAILER_PRODUCT_PRICING_ERROR: {
      return {
        ...initialState,
        error: 'An error has occured',
      };
    }
    default: {
      return state;
    }
  }
};

export default retailerProductPricingReducer;
